export enum ReportAbuseType {
  Question = 'question',
  Answer = 'answer',
  Review = 'review',
}
